import React from 'react';
import { Button, Badge } from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import Table from '../../../shared/table/Table';

const STATUS_BADGE = {
  approved: { colorScheme: 'green', label: 'نشط' },
  pending: { colorScheme: 'orange', label: 'بانتظار الموافقة' },
  rejected: { colorScheme: 'red', label: 'مرفوض' },
};

const TalentsTable = ({ data, page, handleUpdate, handleDelete, handleApprove, handleDisapprove }) => (
  <Table>
    <thead>
      <tr>
        <th>#</th>
        <th>الاسم</th>
        <th>الوصف</th>
        <th>لايك</th>
        <th>ديسلايك</th>
        <th>الحالة</th>
        <th>إجراءات</th>
      </tr>
    </thead>
    <tbody>
      {data?.map((talent, idx) => (
        <tr key={talent._id}>
          <td>{(page - 1) * 10 + idx + 1}</td>
          <td>{talent.name}</td>
          <td>{talent.description?.slice(0, 60)}</td>
          <td>{talent.likes}</td>
          <td>{talent.dislikes}</td>
          <td>
            <Badge colorScheme={STATUS_BADGE[talent.status]?.colorScheme}>
              {STATUS_BADGE[talent.status]?.label}
            </Badge>
          </td>
          <td>
            {talent.status !== 'approved' && (
              <Button bg="transparent" color="teal.300" size="xs" title="موافقة" onClick={() => handleApprove(talent)}>
                <FiIcons.FiCheckCircle size={20} />
              </Button>
            )}
            {talent.status !== 'rejected' && (
              <Button bg="transparent" color="orange.400" size="xs" title="رفض" onClick={() => handleDisapprove(talent)}>
                <FiIcons.FiXCircle size={20} />
              </Button>
            )}
            <Button bg="transparent" color="green" size="xs" onClick={() => handleUpdate(talent)}>
              <FiIcons.FiEdit size={20} />
            </Button>
            <Button bg="transparent" color="red.600" size="xs" onClick={() => handleDelete(talent)}>
              <FiIcons.FiDelete size={20} />
            </Button>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default TalentsTable;
